import React from "react";
import { Button, message, Input, Menu, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useEnquiryModel } from "../enquiryModel";
import useNavModel from "@/model/navModel";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YhAuth } from "@/components/auth/YhAuth";
export const DataBox = () => {
    const { descRows, exportData } = useEnquiryModel();
    const { addNav } = useNavModel();

    const onCreate = () => {
        const materialList = descRows.map((e: any) => ({
            ...e,
            materialCode: e.code,
            materialName: e.name,
            vehicleModel: "",
            unitCode: "",
            unitName: "",
            num: 1,
        }))
        addNav("11-6-1", { id: "", mode: "add", materialList: materialList });
    }

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.VRM2_STT_PL_GENERATEINQUIRYSHEET}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => { onCreate() }}
            >符合条件生成询价单</Button>
        </YhAuth >
        <YhAuth resCode={ResourceAuthEnum.VRM2_STT_PL_GENERATEEXPORT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => exportData()}
            >导出</Button>
        </YhAuth>
    </>;

    return (
        <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
            <DataTable />
        </YhBox>
    )
}